export default "__VITE_ASSET__BF6eeJcS__"